import { useDelete } from '@refinedev/core';

export function useDeleteFundDocument() {
  const { mutateAsync, error, isLoading, reset } = useDelete();

  const deleteFundDocument = async (fundId: string, id: string) => {
    return mutateAsync({
      resource: `funds/${fundId}/files`,
      id,
    });
  };

  return {
    deleteFundDocument,
    error,
    isLoading,
    reset,
  };
}
